// TipoISC constants
const IMPUESTO_ADICIONAL_ISC_SERVICIOS_SEGURO_GENERAL = "003";
const IMPUESTO_ADICIONAL_ISC_SERVICIOS_SEGURO_GENERAL_LABEL = "Servicios Seguros en general";
const IMPUESTO_ADICIONAL_ISC_SERVICIOS_TELECOMUNICACIONES = "004";
const IMPUESTO_ADICIONAL_ISC_SERVICIOS_TELECOMUNICACIONES_LABEL = "Servicios de Telecomunicaciones";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_CERVEZA = "006";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_CERVEZA_LABEL = "ISC Específico Cerveza";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_VINOS_UVA = "007";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_VINOS_UVA_LABEL = "ISC Específico Vinos de Uva";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_VERMUT_DEMAS_VINOS = "008";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_VERMUT_DEMAS_VINOS_LABEL = "ISC Específico Vermut y demás vinos de uvas frescas";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_DEMAS_BEBIDAS_FERMENTADAS = "009";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_DEMAS_BEBIDAS_FERMENTADAS_LABEL = "ISC Específico Demás bebidas fermentadas";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_ALCOHOL_ETILICO_SIN_DESNATURALIZAR_MAYOR_80 = "010";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_ALCOHOL_ETILICO_SIN_DESNATURALIZAR_MAYOR_80_LABEL = "ISC Específico Alcohol Etílico sin desnaturalizar (Mayor o igual a 80%)";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_ALCOHOL_ETILICO_SIN_DESNATURALIZAR_MENOR_80 = "011";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_ALCOHOL_ETILICO_SIN_DESNATURALIZAR_MENOR_80_LABEL = "ISC Específico Alcohol Etílico sin desnaturalizar (inferior a 80%)";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_AGUARDIENTE_UVA = "012";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_AGUARDIENTE_UVA_LABEL = "ISC Específico Aguardientes de uva";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_WHISKY = "013";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_WHISKY_LABEL = "ISC Específico Whisky";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_RON_DEMAS_AGUARDIENTES_CANA = "014";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_RON_DEMAS_AGUARDIENTES_CANA_LABEL = "ISC Específico Ron y demás aguardientes de caña";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_GIN_GINEBRA = "015";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_GIN_GINEBRA_LABEL = "ISC Específico Gin y Ginebra";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_VODKA = "016";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_VODKA_LABEL = "ISC Específico Vodka";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_LICORES = "017";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_LICORES_LABEL = "ISC Específico Licores";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_DEMAS_BEBIDAS_ALCOHOLES = "018";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_DEMAS_BEBIDAS_ALCOHOLES_LABEL = "ISC Específico Los demás (Bebidas y Alcoholes)";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_CIGARROS_TABACO_CAJETILLA_20_UNIDADES = "019";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_CIGARROS_TABACO_CAJETILLA_20_UNIDADES_LABEL = "ISC Específico Cigarrillos que contengan tabaco cajetilla 20 unidades";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_DEMAS_CIGARROS_CAJETILLA_20_UNIDADES = "020";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_DEMAS_CIGARROS_CAJETILLA_20_UNIDADES_LABEL = "ISC Específico Los demás Cigarrillos que contengan 20 unidades";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_CIGARROS_CAJETILLA_10_UNIDADES = "021";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_CIGARROS_CAJETILLA_10_UNIDADES_LABEL = "ISC Específico Cigarrillos que contengan 10 unidades";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_DEMAS_CIGARROS_CAJETILLA_10_UNIDADES = "022";
const IMPUESTO_ADICIONAL_ISC_ESPECIFICO_DEMAS_CIGARROS_CAJETILLA_10_UNIDADES_LABEL = "ISC Específico Los demás Cigarrillos que contengan 10 unidades";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_CERVEZA = "023";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_CERVEZA_LABEL = "ISC AdValorem Cerveza";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_VINOS_UVA = "024";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_VINOS_UVA_LABEL = "ISC AdValorem Vinos de Uva";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_VERMUT_DEMAS_VINOS = "025";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_VERMUT_DEMAS_VINOS_LABEL = "ISC AdValorem Vermut y demás vinos de uvas frescas";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_DEMAS_BEBIDAS_FERMENTADAS = "026";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_DEMAS_BEBIDAS_FERMENTADAS_LABEL = "ISC AdValorem Demás bebidas fermentadas";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_ALCOHOL_ETILICO_SIN_DESNATURALIZAR_MAYOR_80 = "027";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_ALCOHOL_ETILICO_SIN_DESNATURALIZAR_MAYOR_80_LABEL = "ISC AdValorem Alcohol Etílico sin desnaturalizar (Mayor o igual a 80%)";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_ALCOHOL_ETILICO_SIN_DESNATURALIZAR_MENOR_80 = "028";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_ALCOHOL_ETILICO_SIN_DESNATURALIZAR_MENOR_80_LABEL = "ISC AdValorem Alcohol Etílico sin desnaturalizar (inferior a 80%)";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_AGUARDIENTE_UVA = "029";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_AGUARDIENTE_UVA_LABEL = "ISC AdValorem Aguardientes de uva";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_WHISKY = "030";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_WHISKY_LABEL = "ISC AdValorem Whisky";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_RON_DEMAS_AGUARDIENTES_CANA = "031";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_RON_DEMAS_AGUARDIENTES_CANA_LABEL = "ISC AdValorem Ron y demás aguardientes de caña";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_GIN_GINEBRA = "032";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_GIN_GINEBRA_LABEL = "ISC AdValorem Gin y Ginebra";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_VODKA = "033";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_VODKA_LABEL = "ISC AdValorem Vodka";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_LICORES = "034";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_LICORES_LABEL = "ISC AdValorem Licores";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_DEMAS_BEBIDAS_ALCOHOLES = "035";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_DEMAS_BEBIDAS_ALCOHOLES_LABEL = "ISC AdValorem Los demás (Bebidas y Alcoholes)";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_CIGARROS_TABACO_CAJETILLA_20_UNIDADES = "036";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_CIGARROS_TABACO_CAJETILLA_20_UNIDADES_LABEL = "ISC AdValorem Cigarrillos que contengan tabaco cajetilla 20 unidades";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_DEMAS_CIGARROS_CAJETILLA_20_UNIDADES = "037";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_DEMAS_CIGARROS_CAJETILLA_20_UNIDADES_LABEL = "ISC AdValorem Los demás Cigarrillos que contengan 20 unidades";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_CIGARROS_CAJETILLA_10_UNIDADES = "038";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_CIGARROS_CAJETILLA_10_UNIDADES_LABEL = "ISC AdValorem Cigarrillos que contengan 10 unidades";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_DEMAS_CIGARROS_CAJETILLA_10_UNIDADES = "039";
const IMPUESTO_ADICIONAL_ISC_ADVALOREM_DEMAS_CIGARROS_CAJETILLA_10_UNIDADES_LABEL = "ISC AdValorem Los demás Cigarrillos que contengan 10 unidades";

// OtroImpuesto constants
const IMPUESTO_ADICIONAL_PROPINA_LEGAL = "001";
const IMPUESTO_ADICIONAL_PROPINA_LEGAL_LABEL = "Propina Legal";
const IMPUESTO_ADICIONAL_CONTRIBUCION_DESARROLLO_TELECOMUNICACIONES = "002";
const IMPUESTO_ADICIONAL_CONTRIBUCION_DESARROLLO_TELECOMUNICACIONES_LABEL = "Contribución al Desarrollo de las Telecomunicaciones Ley 153-98 Art. 45";
const IMPUESTO_ADICIONAL_EXPEDICION_PRIMERA_PLACA = "005";
const IMPUESTO_ADICIONAL_EXPEDICION_PRIMERA_PLACA_LABEL = "Expedición de la primera placa";

// Estados
export const ESTATUS_ACTIVO = "A";
export const ESTATUS_ACTIVO_LABEL = "Activo";
export const ESTATUS_INACTIVO = "I";
export const ESTATUS_INACTIVO_LABEL = "Inactivo";

// Indicador de Facturación
const INDICADOR_FACTURACION_NO_FACTURABLE = 0;
const INDICADOR_FACTURACION_NO_FACTURABLE_LABEL = "No Facturable";
const INDICADOR_FACTURACION_ITBIS_TASA_1 = 1;
const INDICADOR_FACTURACION_ITBIS_TASA_1_LABEL = "ITBIS 18%";
const INDICADOR_FACTURACION_ITBIS_TASA_2 = 2;
const INDICADOR_FACTURACION_ITBIS_TASA_2_LABEL = "ITBIS 16%";
const INDICADOR_FACTURACION_ITBIS_TASA_3 = 3;
const INDICADOR_FACTURACION_ITBIS_TASA_3_LABEL = "ITBIS 0%";
const INDICADOR_FACTURACION_ITBIS_EXENTO = 4;
const INDICADOR_FACTURACION_ITBIS_EXENTO_LABEL = "Exento";
const INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO = 5;
const INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO_LABEL = "ITBIS 18% del 10%";

// Indicador de Bien o Servicio
export const ITEM_INDICADOR_BIEN = 1;
export const ITEM_INDICADOR_BIEN_LABEL = "Bien";
export const ITEM_INDICADOR_SERVICIO = 2;
export const ITEM_INDICADOR_SERVICIO_LABEL = "Servicio";

export class Item {
  static get ESTATUS_LIST() {
    return [
      { value: ESTATUS_ACTIVO, label: ESTATUS_ACTIVO_LABEL },
      { value: ESTATUS_INACTIVO, label: ESTATUS_INACTIVO_LABEL },
    ];
  };

  static get INDICADOR_BIEN_O_SERVICIO_LIST() {
    return [
      { value: ITEM_INDICADOR_BIEN, label: ITEM_INDICADOR_BIEN_LABEL },
      { value: ITEM_INDICADOR_SERVICIO, label: ITEM_INDICADOR_SERVICIO_LABEL },
    ];
  };

  static get INDICADOR_FACTURACION_LIST() {
    return [
      { value: INDICADOR_FACTURACION_NO_FACTURABLE, label: INDICADOR_FACTURACION_NO_FACTURABLE_LABEL },
      { value: INDICADOR_FACTURACION_ITBIS_TASA_1, label: INDICADOR_FACTURACION_ITBIS_TASA_1_LABEL },
      { value: INDICADOR_FACTURACION_ITBIS_TASA_2, label: INDICADOR_FACTURACION_ITBIS_TASA_2_LABEL },
      { value: INDICADOR_FACTURACION_ITBIS_TASA_3, label: INDICADOR_FACTURACION_ITBIS_TASA_3_LABEL },
      { value: INDICADOR_FACTURACION_ITBIS_EXENTO, label: INDICADOR_FACTURACION_ITBIS_EXENTO_LABEL },
      { value: INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO, label: INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO_LABEL },
    ];
  };

  static getFacturacionLabel(indicador) {
    switch (indicador) {
      case INDICADOR_FACTURACION_NO_FACTURABLE:
        return INDICADOR_FACTURACION_NO_FACTURABLE_LABEL;
      case INDICADOR_FACTURACION_ITBIS_TASA_1:
        return INDICADOR_FACTURACION_ITBIS_TASA_1_LABEL;
      case INDICADOR_FACTURACION_ITBIS_TASA_2:
        return INDICADOR_FACTURACION_ITBIS_TASA_2_LABEL;
      case INDICADOR_FACTURACION_ITBIS_TASA_3:
        return INDICADOR_FACTURACION_ITBIS_TASA_3_LABEL;
      case INDICADOR_FACTURACION_ITBIS_EXENTO:
        return INDICADOR_FACTURACION_ITBIS_EXENTO_LABEL;
      case INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO:
        return INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO_LABEL;
    }
  };

  static getEstatusLabel(estatus) {
    switch (estatus) {
      case ESTATUS_ACTIVO:
        return ESTATUS_ACTIVO_LABEL;
      case ESTATUS_INACTIVO:
        return ESTATUS_INACTIVO_LABEL;
    }
  };

  static getIndicadorBienServicioLabel(indicador) {
    switch (indicador) {
      case ITEM_INDICADOR_BIEN:
        return ITEM_INDICADOR_BIEN_LABEL;
      case ITEM_INDICADOR_SERVICIO:
        return ITEM_INDICADOR_SERVICIO_LABEL;
    }
  };

  static get DEFAULT_ESTATUS_VALUE() {
    return ESTATUS_ACTIVO;
  };

  static get TIPO_ISC_LIST() {
    return [
      { value: IMPUESTO_ADICIONAL_ISC_SERVICIOS_SEGURO_GENERAL, label: IMPUESTO_ADICIONAL_ISC_SERVICIOS_SEGURO_GENERAL_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_SERVICIOS_TELECOMUNICACIONES, label: IMPUESTO_ADICIONAL_ISC_SERVICIOS_TELECOMUNICACIONES_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_CERVEZA, label: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_CERVEZA_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_VINOS_UVA, label: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_VINOS_UVA_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_VERMUT_DEMAS_VINOS, label: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_VERMUT_DEMAS_VINOS_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_DEMAS_BEBIDAS_FERMENTADAS, label: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_DEMAS_BEBIDAS_FERMENTADAS_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_ALCOHOL_ETILICO_SIN_DESNATURALIZAR_MAYOR_80, label: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_ALCOHOL_ETILICO_SIN_DESNATURALIZAR_MAYOR_80_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_ALCOHOL_ETILICO_SIN_DESNATURALIZAR_MENOR_80, label: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_ALCOHOL_ETILICO_SIN_DESNATURALIZAR_MENOR_80_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_AGUARDIENTE_UVA, label: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_AGUARDIENTE_UVA_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_WHISKY, label: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_WHISKY_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_RON_DEMAS_AGUARDIENTES_CANA, label: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_RON_DEMAS_AGUARDIENTES_CANA_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_GIN_GINEBRA, label: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_GIN_GINEBRA_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_VODKA, label: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_VODKA_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_LICORES, label: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_LICORES_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_DEMAS_BEBIDAS_ALCOHOLES, label: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_DEMAS_BEBIDAS_ALCOHOLES_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_CIGARROS_TABACO_CAJETILLA_20_UNIDADES, label: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_CIGARROS_TABACO_CAJETILLA_20_UNIDADES_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_DEMAS_CIGARROS_CAJETILLA_20_UNIDADES, label: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_DEMAS_CIGARROS_CAJETILLA_20_UNIDADES_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_CIGARROS_CAJETILLA_10_UNIDADES, label: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_CIGARROS_CAJETILLA_10_UNIDADES_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_DEMAS_CIGARROS_CAJETILLA_10_UNIDADES, label: IMPUESTO_ADICIONAL_ISC_ESPECIFICO_DEMAS_CIGARROS_CAJETILLA_10_UNIDADES_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ADVALOREM_CERVEZA, label: IMPUESTO_ADICIONAL_ISC_ADVALOREM_CERVEZA_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ADVALOREM_VINOS_UVA, label: IMPUESTO_ADICIONAL_ISC_ADVALOREM_VINOS_UVA_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ADVALOREM_VERMUT_DEMAS_VINOS, label: IMPUESTO_ADICIONAL_ISC_ADVALOREM_VERMUT_DEMAS_VINOS_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ADVALOREM_DEMAS_BEBIDAS_FERMENTADAS, label: IMPUESTO_ADICIONAL_ISC_ADVALOREM_DEMAS_BEBIDAS_FERMENTADAS_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ADVALOREM_ALCOHOL_ETILICO_SIN_DESNATURALIZAR_MAYOR_80, label: IMPUESTO_ADICIONAL_ISC_ADVALOREM_ALCOHOL_ETILICO_SIN_DESNATURALIZAR_MAYOR_80_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ADVALOREM_ALCOHOL_ETILICO_SIN_DESNATURALIZAR_MENOR_80, label: IMPUESTO_ADICIONAL_ISC_ADVALOREM_ALCOHOL_ETILICO_SIN_DESNATURALIZAR_MENOR_80_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ADVALOREM_AGUARDIENTE_UVA, label: IMPUESTO_ADICIONAL_ISC_ADVALOREM_AGUARDIENTE_UVA_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ADVALOREM_WHISKY, label: IMPUESTO_ADICIONAL_ISC_ADVALOREM_WHISKY_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ADVALOREM_RON_DEMAS_AGUARDIENTES_CANA, label: IMPUESTO_ADICIONAL_ISC_ADVALOREM_RON_DEMAS_AGUARDIENTES_CANA_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ADVALOREM_GIN_GINEBRA, label: IMPUESTO_ADICIONAL_ISC_ADVALOREM_GIN_GINEBRA_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ADVALOREM_VODKA, label: IMPUESTO_ADICIONAL_ISC_ADVALOREM_VODKA_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ADVALOREM_LICORES, label: IMPUESTO_ADICIONAL_ISC_ADVALOREM_LICORES_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ADVALOREM_DEMAS_BEBIDAS_ALCOHOLES, label: IMPUESTO_ADICIONAL_ISC_ADVALOREM_DEMAS_BEBIDAS_ALCOHOLES_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ADVALOREM_CIGARROS_TABACO_CAJETILLA_20_UNIDADES, label: IMPUESTO_ADICIONAL_ISC_ADVALOREM_CIGARROS_TABACO_CAJETILLA_20_UNIDADES_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ADVALOREM_DEMAS_CIGARROS_CAJETILLA_20_UNIDADES, label: IMPUESTO_ADICIONAL_ISC_ADVALOREM_DEMAS_CIGARROS_CAJETILLA_20_UNIDADES_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ADVALOREM_CIGARROS_CAJETILLA_10_UNIDADES, label: IMPUESTO_ADICIONAL_ISC_ADVALOREM_CIGARROS_CAJETILLA_10_UNIDADES_LABEL },
      { value: IMPUESTO_ADICIONAL_ISC_ADVALOREM_DEMAS_CIGARROS_CAJETILLA_10_UNIDADES, label: IMPUESTO_ADICIONAL_ISC_ADVALOREM_DEMAS_CIGARROS_CAJETILLA_10_UNIDADES_LABEL },
    ];
  };

  static get OTRO_IMPUESTO_LIST() {
    return [
      { value: IMPUESTO_ADICIONAL_PROPINA_LEGAL, label: IMPUESTO_ADICIONAL_PROPINA_LEGAL_LABEL },
      { value: IMPUESTO_ADICIONAL_CONTRIBUCION_DESARROLLO_TELECOMUNICACIONES, label: IMPUESTO_ADICIONAL_CONTRIBUCION_DESARROLLO_TELECOMUNICACIONES_LABEL },
      { value: IMPUESTO_ADICIONAL_EXPEDICION_PRIMERA_PLACA, label: IMPUESTO_ADICIONAL_EXPEDICION_PRIMERA_PLACA_LABEL },
    ];
  };

  static get PROPIEDADES_EXPORTAR() {
    const propiedades = [
      { value: "IdSec", label: "ID" },
      { value: "Nombre", label: "Nombre" },
      { value: "IndicadorBienOServicioDesc", label: "Tipo de Item" },
      { value: "PrecioUnitario", label: "Precio" },
      { value: "EstatusDesc", label: "Estatus" },
      { value: "Descripcion", label: "Descripción" },
      { value: "EsVendible", label: "Vendible" },
      { value: "EsComprable", label: "Comprable" },
      { value: "IndicadorFacturacionDesc", label: "Tipo de ITBIS" },
      { value: "TipoISCDesc", label: "Tipo de ISC" },
      { value: "OtroImpuestoDesc", label: "Otro Impuesto" },
      { value: "CodigoBarra", label: "Código de Barra" },
      { value: "CategoriaDesc", label: "Categoría" },
      { value: "CrearUsuario", label: "Crear Usuario" },
      { value: "FechaCreacion", label: "Fecha Creación" },
      { value: "ActualizarUsuario", label: "Actualizar Usuario" },
      { value: "FechaActualizacion", label: "Fecha Actualización" }
    ];
    return propiedades;
  };
}
